import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'

/**
 * Overlay class for the Import/Export action-row dropdowns.
 *
 * antd renders the menu in a portal with its default (light-theme) tokens,
 * which on our dark pages comes out black-on-black. This is the same look the
 * row-action menus in the list tables use, lifted into one place so every
 * action-row dropdown reads the same.
 */
const actionDropdownOverlay = css`
  .ant-dropdown-menu {
    background-color: ${colors.SECONDARY_500};
    border: 1px solid ${colors.SECONDARY_200};
  }
  .ant-dropdown-menu-item {
    color: ${colors.NEUTRAL_0};
  }
  .ant-dropdown-menu-item:hover {
    background-color: ${colors.SECONDARY_300};
  }
  .ant-dropdown-menu-item-disabled {
    color: ${colors.SOFT_STEEL} !important;
  }
`

export default actionDropdownOverlay
